import { Tab, Tabs, Grid, Paper, Button } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { TabPanel } from '../../../components/tab-panel';
import { ServicesTab } from './services-bundle-tab/services-tab';
import { WorkOrdersTab } from './workorders-tab/work-orders-tab';
import { useSaveData } from '../../../hooks/useSaveData';
import { workOrdersApiKeyStore } from '../../../api/workorders-api-key-store';
import { Unit } from '../../../models/unit';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { unitsApiKeyStore } from '../../../api/units-api-key-store';
import { InspectionReportsTab } from './inspection-report-tab/inspection-report.tab';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';

interface DetailsTabsProps {
  unit: Unit;
}

export const DetailsTabs = ({ unit }: DetailsTabsProps) => {
  const { unitID } = useParams();
  const [value, setValue] = useState(unit.workOrderCount > 0 ? 'workOrders' : 'services');
  const {
    isLoading: isGenerating,
    data,
    mutateAsync,
  } = useSaveData<any>(workOrdersApiKeyStore.generateWorkOrder(), () => unitsApiKeyStore.getUnitDetails(unitID));

  const handleTabsChange = (event: any, value: any) => {
    setValue(value);
  };

  const generateWorkOrder = async () => {
    await mutateAsync({ data: { unitID: unitID } });
    setValue('workOrders');
  };

  if (!unitID) {
    return <div>Invalid Unit</div>;
  }


  const isViewWorkOrder = useAuthorize([UserPermissionName?.VIEW_WORKORDER]);
  return (
    <Paper elevation={0}>
      <Grid item>
        <LoadingIndicator isLoading={isGenerating} />
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="workOrders" label="Work Orders" />
          <Tab value="services" label="Services" />
          <Tab value="inspectionReports" label="Inspection Reports" hidden={!isViewWorkOrder} />
          <div className="d-flex justify-content-end" style={{ width: '100%', padding: '8px' }}>
            {unit?.hasPendingWorkOrderGenerations && (
              <Button
                className="btn btn-link"
                variant="outlined"
                onClick={generateWorkOrder}
                style={{ marginLeft: 876 }}
                disabled={isGenerating || !!data}
              >
                Generate Work Order
              </Button>
            )}
          </div>
        </Tabs>

        <TabPanel selectedValue={value} value="workOrders">
          <WorkOrdersTab unit={unit} />
        </TabPanel>
        <TabPanel selectedValue={value} value="services">
          <ServicesTab unitID={Number(unitID)} unit={unit} />
          {/* <ServicesForm name="unitService" id={unit?.unitID} /> */}
        </TabPanel>
        <TabPanel selectedValue={value} value="inspectionReports">
          <InspectionReportsTab unitID={Number(unitID)} customerName={unit?.customerName} />
        </TabPanel>
      </Grid>
    </Paper>
  );
};
